module.exports = __webpack_public_path__ + "cf97f5261c87ceffc3f952e9d727bb7c.jpg";